<ion-grid class="user-pending" *transloco="let t">
  <ion-row>
    <ion-col size="auto" class="ion-flex ion-align-items-center ion-justify-content-center">
    <ion-icon name="close" (click)="onCancel()"></ion-icon>
  </ion-col>
  <ion-col>
          <h6>
          {{ t('auth.userPendingMessage') }}
          <a href="#" (click)="onLinkClick($event)">
            {{ t('auth.userPendingMessageLink') }}
          </a>
        </h6>
  </ion-col>
  </ion-row>
  <div *ngIf="showPopup" class="popup">
  📧 {{t('auth.userPendingResendMessage')}}
  </div>
</ion-grid>

